import { constant, flow, find, get } from 'lodash/fp';
import config from '../../helpers/config';
import prefillAtc from '../../api/oldMandi/prefillAtc';

export default (cartingOptions) => {
  const job = get('job', cartingOptions);

  return prefillAtc(
    get('id', job),
    get('serviceType', job),
    flow(
      get('attributes'),
      find({ name: 'textOptIn' }),
      get('normalizedValue'),
    )(job),
    get('pricingResult.retail', job),
    get('pricingResult.cost', job),
    config.repId(),
    get('customer', job),
    get('address', job),
  )
    .then(constant(cartingOptions));
};
